import { ApiKeys } from '@app/constants/api-keys'
import { IEducationWeeklySchedule } from '@app/interfaces/education/education-weekly-schedule'
import { resolveTParams } from '@app/utils/resolve-params/resolve-params'
import localforage from 'localforage'
import { IRtkResponse } from '../../types'
import { emptyEducationApi } from './index'

export const educationWeeklyScheduleApi = emptyEducationApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (build) => ({
    getEducationWeeklySchedules: build.query<
      IRtkResponse<IEducationWeeklySchedule[]>,
      URLSearchParams | string
    >({
      query: (args = '') => ({
        url: 'education/api/v1/education-group-weekly-work-schedule-dictionary',
        method: 'get',
        params: {
          ...resolveTParams(args),
        },
      }),
      transformResponse: (response: IEducationWeeklySchedule[], meta) => {
        return { response, meta }
      },
      providesTags: (data) =>
        data
          ? [
              ...data.response.map(({ id }) => ({
                type: ApiKeys.educationWeeklySchedule,
                id,
              })),
              { type: ApiKeys.educationWeeklySchedule, id: 'LIST' },
            ]
          : [{ type: ApiKeys.educationWeeklySchedule, id: 'LIST' }],
      async onQueryStarted(args, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          localforage.setItem(ApiKeys.educationWeeklySchedule, data?.response)
        } catch (e) {
          console.error(e)
        }
      },
    }),
    getEducationWeeklySchedule: build.query<IEducationWeeklySchedule, number>({
      query: (id) => ({
        url: `education/api/v1/education-group-weekly-work-schedule-dictionary/${id}`,
        method: 'get',
      }),
      providesTags: (result, error, id) => [
        { type: ApiKeys.educationWeeklySchedule, id },
      ],
    }),
  }),
})

export const {
  useGetEducationWeeklySchedulesQuery,
  useGetEducationWeeklyScheduleQuery,
} = educationWeeklyScheduleApi
